import { gql } from '@apollo/client';

// Documentos GraphQL de "Mi Programa" (nutrición). Consumidos con useQuery/useMutation.

/* --------------------------------- Admin --------------------------------- */
export const NUTRITION_PROGRAMS = gql`
  query NutritionPrograms($first: Int!, $page: Int, $search: String) {
    nutritionPrograms(first: $first, page: $page, search: $search) {
      data { id title type content pdf_url created_at assigned_to assignments_info { id label user_id plan_id } }
      paginatorInfo { currentPage lastPage total }
    }
  }
`;

const RECIPE_FIELDS = `
  id name image_url ingredients steps ingredients_html steps_html difficulty portions position
  accent_color meal_label prep_time background_image_url footer_note illustration
`;

export const RECIPE_BOOKS = gql`
  query RecipeBooks($first: Int!, $page: Int, $search: String) {
    recipeBooks(first: $first, page: $page, search: $search) {
      data {
        id title description cover_url created_at assigned_to assignments_info { id label user_id plan_id }
        recipes { ${RECIPE_FIELDS} }
      }
      paginatorInfo { currentPage lastPage total }
    }
  }
`;

export const CLIENT_INTAKE = gql`
  query ClientIntake($user_id: ID!) {
    clientIntake(user_id: $user_id) {
      id weight height age work_activity food_habits preferences cheat_meals rest supplements dietary_restrictions medical_conditions goal
    }
  }
`;

export const CREATE_PROGRAM = gql`
  mutation CreateNutritionProgram($input: NutritionProgramInput!) {
    createNutritionProgram(input: $input) { id title }
  }
`;
export const UPDATE_PROGRAM = gql`
  mutation UpdateNutritionProgram($id: ID!, $input: NutritionProgramInput!) {
    updateNutritionProgram(id: $id, input: $input) { id title }
  }
`;
export const DELETE_PROGRAMS = gql`
  mutation DeleteNutritionPrograms($id: [ID!]!) { deleteNutritionPrograms(id: $id) { id } }
`;

export const CREATE_RECIPE_BOOK = gql`
  mutation CreateRecipeBook($input: RecipeBookInput!) { createRecipeBook(input: $input) { id title } }
`;
export const UPDATE_RECIPE_BOOK = gql`
  mutation UpdateRecipeBook($id: ID!, $input: RecipeBookInput!) { updateRecipeBook(id: $id, input: $input) { id title } }
`;
export const DELETE_RECIPE_BOOKS = gql`
  mutation DeleteRecipeBooks($id: [ID!]!) { deleteRecipeBooks(id: $id) { id } }
`;

export const CREATE_RECIPE = gql`
  mutation CreateRecipe($input: RecipeInput!) {
    createRecipe(input: $input) { id name ingredients_html steps_html accent_color meal_label prep_time background_image_url footer_note illustration }
  }
`;
export const UPDATE_RECIPE = gql`
  mutation UpdateRecipe($id: ID!, $input: RecipeUpdateInput!) {
    updateRecipe(id: $id, input: $input) { id name ingredients_html steps_html accent_color meal_label prep_time background_image_url footer_note illustration }
  }
`;
export const DELETE_RECIPES = gql`
  mutation DeleteRecipes($id: [ID!]!) { deleteRecipes(id: $id) { id } }
`;
export const REORDER_RECIPES = gql`
  mutation ReorderRecipes($recipe_book_id: ID!, $ordered_ids: [ID!]!) {
    reorderRecipes(recipe_book_id: $recipe_book_id, ordered_ids: $ordered_ids) { id position }
  }
`;

export const ASSIGN_NUTRITION = gql`
  mutation AssignNutrition($nutrition_program_id: ID, $recipe_book_id: ID, $user_id: ID, $plan_id: ID, $general: Boolean) {
    assignNutrition(nutrition_program_id: $nutrition_program_id, recipe_book_id: $recipe_book_id, user_id: $user_id, plan_id: $plan_id, general: $general)
  }
`;

export const UNASSIGN_NUTRITION = gql`
  mutation UnassignNutrition($id: ID!) { unassignNutrition(id: $id) }
`;

/* -------------------------------- Cliente -------------------------------- */
export const MY_PROGRAMS = gql`
  query MyPrograms { myPrograms { id title type content pdf_url } }
`;
export const MY_RECIPE_BOOKS = gql`
  query MyRecipeBooks {
    myRecipeBooks {
      id title description cover_url
      recipes { ${RECIPE_FIELDS} }
    }
  }
`;
export const MY_INTAKE = gql`
  query MyIntake {
    myIntake { id weight height age work_activity food_habits preferences cheat_meals rest supplements dietary_restrictions medical_conditions goal }
  }
`;

// URL presignada del PDF del programa (el bucket es privado → la URL cruda da AccessDenied).
export const NUTRITION_PROGRAM_TEMP_URL = gql`
  query NutritionProgramTemporaryUrl($id: ID!) {
    nutritionProgramTemporaryUrl(id: $id)
  }
`;
export const SUBMIT_INTAKE = gql`
  mutation SubmitIntake($input: ClientIntakeInput!) {
    submitIntake(input: $input) { id }
  }
`;

// El admin guarda la admisión de OTRO usuario (datos que llegan por teléfono o en la sesión).
// Aparte de SUBMIT_INTAKE porque esa siempre escribe sobre el usuario autenticado.
export const SAVE_CLIENT_INTAKE = gql`
  mutation SaveClientIntake($user_id: ID!, $input: ClientIntakeInput!) {
    saveClientIntake(user_id: $user_id, input: $input) { id }
  }
`;
